const createDeeplink = (query: { [key: string]: any }) => {
  return (
    "oeapp://action?" +
    Object.keys(query)
      .map((key) => `${key}=${query[key]}`)
      .join("&")
  );
  // return "oeapp://action?" + new URLSearchParams(query).toString();
};

export default {
  mannerOE: () => createDeeplink({ type: "매너오이" }),
  mannerOEDelivery: (oeId: number, scheduleId: number, contentId: number) => {
    const query = {
      type: "매너오이전달",
      oeId,
    };
    if (scheduleId) {
      // @ts-ignore
      query["scheduleId"] = scheduleId;
    }
    if (contentId) {
      // @ts-ignore
      query["contentId"] = contentId;
    }
    return createDeeplink(query);
  },
  reportDetail: (reportId: number) =>
    createDeeplink({ type: "신고", reportId }),
  myFeedDetail: (feedOwnerId: number, feedId: number) =>
    createDeeplink({ type: "개인피드", feedOwnerId, feedId }),
  myFeedComment: (feedOwnerId: number, feedId: number, commentId: number) =>
    createDeeplink({ type: "개인피드", feedOwnerId, feedId, commentId }),
  gatheringHome: (gatheringId: number) =>
    createDeeplink({ type: "모임", gatheringId }),
  gatheringMember: (gatheringId: number) =>
    createDeeplink({ type: "모임멤버", gatheringId }),
  gatheringJoinRequest: (gatheringId: number, requestId: number) =>
    createDeeplink({ type: "가입신청", gatheringId, requestId }),
  chatRoom: (room: string) => createDeeplink({ type: "채팅방", room }),
  gatheringFeedDetail: (gatheringId: number, feedId: number) =>
    createDeeplink({ type: "모임피드", gatheringId, feedId }),
  gatheringFeedComment: (
    gatheringId: number,
    feedId: number,
    commentId: number
  ) =>
    createDeeplink({
      type: "모임피드댓글",
      gatheringId,
      feedId,
      commentId,
    }),
  gatheringNoticeDetail: (gatheringId: number, noticeId: number) =>
    createDeeplink({ type: "모임공지", gatheringId, noticeId }),
  gatheringNoticeComment: (
    gatheringId: number,
    noticeId: number,
    commentId: number
  ) =>
    createDeeplink({
      type: "모임공지댓글",
      gatheringId,
      noticeId,
      commentId,
    }),
  gatheringScheduleDetail: (gatheringId: number, scheduleId: number) =>
    createDeeplink({ type: "모임일정", gatheringId, scheduleId }),
  gatheringScheduleComment: (
    gatheringId: number,
    scheduleId: number,
    commentId: number
  ) =>
    createDeeplink({
      type: "모임일정댓글",
      gatheringId,
      scheduleId,
      commentId,
    }),
  gatheringVoteDetail: (gatheringId: number, voteId: number) =>
    createDeeplink({
      type: "모임투표",
      gatheringId,
      voteId,
    }),
  gatheringVoteComment: (
    gatheringId: number,
    voteId: number,
    commentId: number
  ) =>
    createDeeplink({
      type: "모임투표댓글",
      gatheringId,
      voteId,
      commentId,
    }),
  gatheringWishList: (gatheringId: number) =>
    createDeeplink({ type: "모임찜하기목록", gatheringId }),
  hotGatheringList: (regionCode: string) =>
    createDeeplink({ type: "지역인기모임", regionCode }),
  webLink: (link: string) => createDeeplink({ type: "웹링크", link }),
  contentHostProfile: (hostId: number) =>
    createDeeplink({ type: "호스트프로필", hostId }),
  contentDetail: (contentId: number) =>
    createDeeplink({ type: "콘텐츠", contentId }),
  contentSettlement: (contentId: number) =>
    createDeeplink({ type: "콘텐츠정산", contentId }),
  contentJoinList: () => createDeeplink({ type: "참가콘텐츠" }),
  contentWishList: (contentId: number) =>
    createDeeplink({ type: "콘텐츠찜하기목록", contentId }),
  contentReviewDetail: (reviewId: number, contentId: number) =>
    createDeeplink({ type: "콘텐츠후기", reviewId, contentId }),
  contentReviewList: (hostId: number) =>
    createDeeplink({ type: "콘텐츠후기목록", hostId }),
  tab: (tab: "홈탭" | "모임찾기" | "즐길거리탭" | "피드탭" | "더보기") =>
    createDeeplink({ type: tab }),

  //   새로생김
  emoticonPurchase: (groupId: number) =>
    createDeeplink({ type: "이모티콘구매", groupId }),
  greeting: (userId: number, gatheringId: number) =>
    createDeeplink({ type: "가입인사", userId, gatheringId }),
  userProfile: (userId: number) =>
    createDeeplink({ type: "개인프로필", userId }),
  hostProfile: (hostId: number) =>
    createDeeplink({ type: "호스트프로필", hostId }),
  reportUser: (userId: number) => createDeeplink({ type: "유저신고", userId }),
};
